import type { Signal } from "../data/api-types";
import { mockToday as today } from "./today";

export const mockSignal: Signal = {
  id: "sig_001",
  customer_id: "cust_012",
  signal_definition_id: "sigdef_order_delay_ratio",
  signal_family: "health",
  signal_name: "Order Delay Ratio",
  signal_value: "1.8x",
  impact: "negative",
  commentary: "Customer is 1.8x their normal days-between-orders cadence.",
  evaluated_at: `${today}T08:00:00Z`,
  contact_id: null,
  source_report_id: null,
  work_category_id: null,
};

export const mockSignals: Signal[] = [
  mockSignal,
  {
    id: "sig_002",
    customer_id: "cust_022",
    signal_definition_id: "sigdef_growth",
    signal_family: "revenue",
    signal_name: "Revenue Growth",
    signal_value: "+24%",
    impact: "very positive",
    commentary: "Revenue last 90d is 24% above the previous 90d.",
    evaluated_at: `${today}T08:00:00Z`,
    contact_id: null,
    source_report_id: null,
    work_category_id: null,
  },
  {
    id: "sig_003",
    customer_id: "cust_048",
    signal_definition_id: "sigdef_engagement",
    signal_family: "engagement",
    signal_name: "Active Engagement",
    signal_value: "high",
    impact: "positive",
    commentary: "Multiple stakeholder interactions in the last 30 days.",
    evaluated_at: `${today}T08:00:00Z`,
    contact_id: null,
    source_report_id: null,
    work_category_id: null,
  },
  {
    id: "sig_004",
    customer_id: "cust_073",
    signal_definition_id: "sigdef_dropoff",
    signal_family: "health",
    signal_name: "Order Dropoff",
    signal_value: "27d",
    impact: "very negative",
    commentary: "27 days since last order vs 35d normal cadence.",
    evaluated_at: `${today}T08:00:00Z`,
    contact_id: null,
    source_report_id: null,
    work_category_id: null,
  },
];
